import React from 'react';
import { ThemeProvider as SCThemeProvider } from 'styled-components';
import {
  ThemeProvider as MuiThemeProvider,
  StyledEngineProvider as MuiStyledEngineProvider,
} from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import GlobalStyles from '../styles/globalStyles';
import theme from '../styles/theme';

type Props = { readonly children: React.ReactNode };

function ThemeProvider({ children }: Props) {
  GlobalStyles();
  return (
    <>
      <CssBaseline />
      <MuiStyledEngineProvider injectFirst>
        <MuiThemeProvider theme={theme}>
          <SCThemeProvider theme={theme}>{children}</SCThemeProvider>
        </MuiThemeProvider>
      </MuiStyledEngineProvider>
    </>
  );
}
export default ThemeProvider;
